<div class="ngx-text-highlight-element"
     [ngStyle]="highlightElementContainerStyle"
     [innerHtml]="highlightedText"
     #highlightElement></div>